// extracted by mini-css-extract-plugin
module.exports = {"coBrandedLogo":"CoBranding_coBrandedLogo___kTKA","coBrandedName":"CoBranding_coBrandedName__3dIr-"};